
<form class="ui form" @submit.prevent="send" :class="{'warning': form.hasErrors()}">
  <div class="field">
    <label>入力したメールアドレスにパスワード再設定URLをお送りします。</label>
    <div class="ui left icon input">
      <i class="envelope outline icon"></i>
      <input v-model="form.model.email" type="text" :placeholder="'メールアドレス'">
    </div>
    <validation-message :form="form" :field="'email'"></validation-message>
  </div>
  <div v-if="!mailSent" class="field">
    <button type="submit" class="ui fluid orange submit button" :class="{'loading': form.waiting}">送信する</button>
  </div>
  <div v-if="mailSent" class="ui positive message">
    <div>メールを送信しました</div>
  </div>
</form>
